import { create } from 'zustand';

export interface AgentEvent {
    id: string;
    type: 'info' | 'success' | 'warning' | 'error';
    category: 'system' | 'agent' | 'user' | 'tool' | 'scheduler';
    title: string;
    description?: string;
    timestamp: number;
    sessionId?: string;
    taskId?: string;
    metadata?: Record<string, unknown>;
    read: boolean;
}

interface EventLogStore {
    events: AgentEvent[];
    unreadCount: number;

    addEvent: (event: Omit<AgentEvent, 'id' | 'timestamp' | 'read'>) => void;
    markAllAsRead: () => void;
    markCategoryAsRead: (category: AgentEvent['category']) => void;
    clearEvents: () => void;
    getEventsBySession: (sessionId: string) => AgentEvent[];
}

export const useEventLogStore = create<EventLogStore>((set, get) => ({
    events: [],
    unreadCount: 0,

    addEvent: (event) => {
        const newEvent: AgentEvent = {
            id: Math.random().toString(36).substring(7),
            timestamp: Date.now(),
            read: false,
            ...event,
        };

        set((state) => ({
            events: [newEvent, ...state.events].slice(0, 100), // Keep last 100 events
            unreadCount: state.unreadCount + 1,
        }));
    },

    markAllAsRead: () => set((state) => ({
        events: state.events.map((e) => ({ ...e, read: true })),
        unreadCount: 0,
    })),

    markCategoryAsRead: (category) => set((state) => {
        const updatedEvents = state.events.map((e) =>
            e.category === category ? { ...e, read: true } : e
        );
        const newUnreadCount = updatedEvents.filter((e) => !e.read).length;
        return {
            events: updatedEvents,
            unreadCount: newUnreadCount,
        };
    }),

    clearEvents: () => set({ events: [], unreadCount: 0 }),

    getEventsBySession: (sessionId) => {
        return get().events.filter(e => e.sessionId === sessionId);
    }
}));



